import { Machine, assign } from 'xstate'
import { searchNetsuite } from 'api'

interface Context {
  query?: string
  total?: number
  results?: any[]
  error?: string
}

type Events = { type: 'SEARCH_CHANGE' }

const stateChart = {
  id: 'searchNetsuite',
  context: {
    query: '',
    total: 0,
    results: [],
    error: undefined,
  },
  initial: 'idle',
  states: {
    idle: {
      entry: 'setQuery',
    },
    debouncing: {
      entry: 'setQuery',
      after: {
        300: 'searching',
      },
    },
    searching: {
      invoke: {
        id: 'getSearchResults',
        src: 'fetchResults',
        onDone: {
          target: 'successful',
          actions: ['setResults'],
        },
        onError: {
          target: 'failed',
          actions: ['setError'],
        },
      },
    },
    successful: {
      always: [
        {
          cond: 'noResults',
          target: 'noResults',
        },
        {
          target: 'hasResults',
        },
      ],
    },
    failed: {},
    hasResults: {},
    noResults: {},
  },
  on: {
    SEARCH_CHANGE: [
      {
        cond: 'isSearchEmpty',
        target: 'idle',
        actions: ['resetResults'],
      },
      {
        cond: 'isQueryValid',
        target: 'debouncing',
      },
    ],
  },
}

const config = {
  actions: {
    setResults: assign((__context: any, event: any) => ({
      results: event.data.results,
      total: event.data.total,
    })),
    setQuery: assign((__context: any, event: any) => ({
      query: event.query,
    })),
    resetResults: assign((__context: any, event: any) => ({
      results: [],
      total: 0,
    })),
    setError: assign((__context: any, event: any) => ({
      error:
        typeof event.data === 'string'
          ? event.data
          : event.data?.message ?? event.data?.error,
    })),
  },
  guards: {
    isQueryValid: (__context: any, event: any) => {
      return event.query.length > 1
    },
    isSearchEmpty: (__context: any, event: any) => {
      return !event.query || event.query.length === 0 || event.query.length < 2
    },
    noResults: (__context: any, event: any) => {
      return __context.total === 0
    },
  },
  services: {
    fetchResults: (__context: any) => {
      return searchNetsuite({ query: __context.query })
    },
  },
}

export const searchNetsuiteMachine = Machine<Context, Events>(
  stateChart,
  config
)
